export default "__VITE_ASSET__232521c8__"